import React, { useState } from 'react';
import tinycolor from 'tinycolor2';
import '../../styles/NavbarButton.css';

type NavbarButtonProps = {
  text?: string;
  fontSize?: string;
  fontWeight?: number | string;
  lineHeight?: string;
  width?: string;
  height?: string;
  color?: string;
  backgroundColor?: string;
  icon?: React.ElementType;
  onClick?: () => void;
  style?: React.CSSProperties;
};

const NavbarButton: React.FC<NavbarButtonProps> = ({
  text = 'Dashboard',
  fontSize = '16px',
  fontWeight = 500,
  lineHeight = '20px',
  width = '90%',
  height = '48px',
  color = '#000000',
  backgroundColor = '#ffffff',
  icon: Icon,
  onClick,
  style = {},
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const hoverBackgroundColor = tinycolor(backgroundColor).darken(6).toString();

  const combinedStyles: React.CSSProperties = {
    fontFamily: 'Montserrat',
    fontSize,
    fontWeight,
    lineHeight,
    color,
    backgroundColor: isHovered ? hoverBackgroundColor : backgroundColor,
    cursor: 'pointer',
    width,
    height,
    padding: '8px 16px',
    border: 'none',
    borderRadius: '16px',
    outline: 'none',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'background-color 0.2s ease, transform 0.1s ease',
    ...style,
  };

  return (
    <button
      className="navbar-button"
      onClick={onClick}
      style={combinedStyles}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {Icon && <Icon style={{ fontSize }} />}
      <span>{text}</span>
    </button>
  );
};

export default NavbarButton;
